
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class SettingsSelect extends Vue {
  private items = [
    {
      value: 'shipments',
      text: this.$t('preferences.notifications.shipments'),
    },
    {
      value: 'packages',
      text: this.$t('preferences.notifications.packages'),
    },
    {
      value: 'serviceLevelAndPricing',
      text: this.$t('preferences.notifications.serviceAndPricing'),
    },
    {
      value: 'customs',
      text: this.$t('preferences.notifications.customs'),
    },
    {
      value: 'pickupOrDropOff',
      text: this.$t('preferences.notifications.pickupOrDropOff'),
    },
    {
      value: 'general',
      text: this.$t('preferences.notifications.general'),
    },
  ];

  private selectedItem = this.$route.query.content;

  private handleInput(content): void {
    this.$router.push({ query: { content } });
  }
}
